// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   PanelSidebar — contenedor posicionado absoluto
   ═══════════════════════════════════════════════ */
.sidebar-container {
  position: absolute;
  top: 10%;
  right: 3%;
  z-index: 10;
  width: 252px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ── Tabs ────────────────────────────────────────── */
.sidebar-tabs {
  display: flex;
  background: #ffffff;
  border: 0.5px solid rgba(0, 0, 0, 0.14);
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  border-bottom: none;
}

.sidebar-tab {
  flex: 1 1;
  padding: 9px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #888;
  background: #fafafa;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: background 0.15s, color 0.15s;
  border-bottom: 2px solid transparent;
}
.sidebar-tab:first-child {
  border-right: 0.5px solid rgba(0, 0, 0, 0.10);
}
.sidebar-tab:hover {
  background: #f0f0f0;
  color: #444;
}
.sidebar-tab--active {
  background: #ffffff;
  color: #1a1a1a;
  border-bottom: 2px solid #185FA5;
}
.sidebar-tab:last-child.sidebar-tab--active {
  border-bottom-color: #534AB7;
}

/* ── Badges en tabs ──────────────────────────────── */
.sidebar-tab-badge {
  font-size: 10px;
  font-weight: 500;
  padding: 1px 5px;
  border-radius: 5px;
  line-height: 1.4;
}
.sidebar-tab-badge--blue   { background: #E6F1FB; color: #185FA5; }
.sidebar-tab-badge--purple { background: #EEEDFE; color: #534AB7; }

/* ── Panel hijo — quita su propio posicionamiento ── */

/*
  Tanto PanelCorrelaciones (.pc-panel) como PanelExcepcion (.pe-panel)
  se renderizan dentro de este contenedor, así que sobreescribimos su
  position/top/right para que fluyan naturalmente dentro del sidebar.
*/
.sidebar-container .pc-panel,
.sidebar-container .pe-panel {
  position: static;
  width: 100%;
  border-radius: 0 0 12px 12px;
  border-top: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/PanelSidebar.css"],"names":[],"mappings":"AAAA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yCAAyC;EACzC,oCAAoC;AACtC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE,uDAAuD;;AAEvD;;;;CAIC;AACD;;EAEE,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;AAC3C","sourcesContent":["/* ═══════════════════════════════════════════════\n   PanelSidebar — contenedor posicionado absoluto\n   ═══════════════════════════════════════════════ */\n.sidebar-container {\n  position: absolute;\n  top: 10%;\n  right: 3%;\n  z-index: 10;\n  width: 252px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ── Tabs ────────────────────────────────────────── */\n.sidebar-tabs {\n  display: flex;\n  background: #ffffff;\n  border: 0.5px solid rgba(0, 0, 0, 0.14);\n  border-radius: 12px 12px 0 0;\n  overflow: hidden;\n  border-bottom: none;\n}\n\n.sidebar-tab {\n  flex: 1;\n  padding: 9px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #888;\n  background: #fafafa;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  transition: background 0.15s, color 0.15s;\n  border-bottom: 2px solid transparent;\n}\n.sidebar-tab:first-child {\n  border-right: 0.5px solid rgba(0, 0, 0, 0.10);\n}\n.sidebar-tab:hover {\n  background: #f0f0f0;\n  color: #444;\n}\n.sidebar-tab--active {\n  background: #ffffff;\n  color: #1a1a1a;\n  border-bottom: 2px solid #185FA5;\n}\n.sidebar-tab:last-child.sidebar-tab--active {\n  border-bottom-color: #534AB7;\n}\n\n/* ── Badges en tabs ──────────────────────────────── */\n.sidebar-tab-badge {\n  font-size: 10px;\n  font-weight: 500;\n  padding: 1px 5px;\n  border-radius: 5px;\n  line-height: 1.4;\n}\n.sidebar-tab-badge--blue   { background: #E6F1FB; color: #185FA5; }\n.sidebar-tab-badge--purple { background: #EEEDFE; color: #534AB7; }\n\n/* ── Panel hijo — quita su propio posicionamiento ── */\n\n/*\n  Tanto PanelCorrelaciones (.pc-panel) como PanelExcepcion (.pe-panel)\n  se renderizan dentro de este contenedor, así que sobreescribimos su\n  position/top/right para que fluyan naturalmente dentro del sidebar.\n*/\n.sidebar-container .pc-panel,\n.sidebar-container .pe-panel {\n  position: static;\n  width: 100%;\n  border-radius: 0 0 12px 12px;\n  border-top: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
